import { Button } from "@/components/core/buttons/button";
import Combobox from "@/components/core/forms/combobox";
import { Form, FormDescription } from "@/components/core/forms/form.tsx";
import { FormField, FormGroup, FormItem, FormLabel, FormMessage } from "@/components/core/forms/form.tsx";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { useForm } from "react-hook-form";
import roleService from "../api/services/role-service";
import type { Role, RoleCreateSchema } from "../types/role";

export default function RoleCreateModal({ handleSubmit }: { handleSubmit: any }) {
	const { closeModal } = useModalControl();

	const form = useForm<RoleCreateSchema>({
		defaultValues: {
			role_id: "",
			name: "",
		},
	});

	const submit = async (values: RoleCreateSchema) => {
		handleSubmit(values);
		closeModal();
	};

	const loadRoleOptions = async (value: string): Promise<{ value: string; label: string }[]> => {
		const items = await roleService.list({
			"filter[search]": value,
		});

		return (items || []).map((item: Role) => ({
			value: item.id,
			label: item.name,
		}));
	};

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(submit)}>
				<div className="grid grid-cols-12 w-full gap-3 py-3">
					<div className="col-span-12 w-full">
						<FormField
							control={form.control}
							name="role_id"
							render={({ field }) => (
								<FormItem>
									<div className="flex flex-col w-full">
										<FormLabel required>Roles</FormLabel>
										<FormDescription />
									</div>
									<FormGroup iconPosition="left">
										<Combobox
											defaultValue={field.value}
											onValueChange={(value) => {
												field.onChange(value?.value);
												form.setValue("name", value?.label ?? "");
											}}
											returnFullOption={true}
											loadOptions={loadRoleOptions}
										/>
									</FormGroup>
									<FormMessage />
								</FormItem>
							)}
						/>
					</div>
				</div>
				<div className="flex flex-row justify-between w-full gap-4 mt-2">
					<Button
						className=""
						variant="ghost"
						type="button"
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</Button>
					<Button className="" variant="default">
						Confirm
					</Button>
				</div>
			</form>
		</Form>
	);
}
